import { documentCategoryService } from '@/services/api/documentCategory.service';
import { documentCategoryModel } from '@/models/api/documentCategory.model';
import { sharedHelper, alertHelper } from '@/utils';
import i18n from '@/i18n';

export const DOCUMENT_CATEGORY_MODULE = 'api/documentCategory';
export const GET_ALL_DOCUMENT_CATEGORY = 'getAllDocumentCategory';
export const CREATE_DOCUMENT_CATEGORY = 'createDocumentCategory';
export const GET_DOCUMENT_CATEGORY = 'getDocumentCategory';
export const UPDATE_DOCUMENT_CATEGORY = 'updateDocumentCategory';
export const UPDATE_DOCUMENT_CATEGORY_STATUS = 'updateDocumentCategoryStatus';
export const DELETE_DOCUMENT_CATEGORY = 'deleteDocumentCategory';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 1,
            pageSize: 15,
            lastPage: 1,
            tableRowsCounts: 0,
            total: 0
        }
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true
    },
};

function showError(commit, error) {
    commit('failure');
    alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
}

export const actions = {
    async [GET_ALL_DOCUMENT_CATEGORY]({ commit }, { filter }) {
        commit('requesting');
        try {
            const result = await documentCategoryService.getAll(filter);
            commit('listSuccess', result);
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [CREATE_DOCUMENT_CATEGORY]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await documentCategoryService.store(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.createXSuccess', [i18n.t('module.documentCategory')]) });
            await dispatch(GET_ALL_DOCUMENT_CATEGORY, { filter });
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [GET_DOCUMENT_CATEGORY]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const result = await documentCategoryService.show(uuid);
            commit('detailSuccess', result);
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [UPDATE_DOCUMENT_CATEGORY]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await documentCategoryService.update(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.updateXSuccess', [i18n.t('module.documentCategory')]) });
            await dispatch(GET_ALL_DOCUMENT_CATEGORY, { filter });
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [UPDATE_DOCUMENT_CATEGORY_STATUS]({ commit, dispatch }, { uuid, isActive, filter }) {
        commit('requesting', 'save');
        try {
            const result = await documentCategoryService.updateStatus(uuid, isActive);
            commit('success');
            await dispatch(GET_ALL_DOCUMENT_CATEGORY, { filter });
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [DELETE_DOCUMENT_CATEGORY]({ commit, dispatch }, { uuid, filter }) {
        commit('requesting', 'save');
        try {
            const result = await documentCategoryService.softDelete(uuid);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.deleteXSuccess', [i18n.t('module.documentCategory')]) });
            await dispatch(GET_ALL_DOCUMENT_CATEGORY, { filter });
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
};

export const mutations = {
    requesting(state, type = 'list') {
        state.status[type] = false;
    },
    listSuccess(state, result) {
        state.list.data = (result?.data || []).map(documentCategoryModel);
        state.list.pagination = sharedHelper.apiPaginationAdapter(result?.pagination || {});
        state.status.list = true;
    },
    detailSuccess(state, result) {
        const payload = result?.data || {};
        state.details = documentCategoryModel(payload);
        state.status.detail = true;
    },
    success(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
    failure(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
};
